import { render } from "./ListeFicheStock.vue?vue&type=template&id=077f5e08&ts=true"
import script from "./ListeFicheStock.vue?vue&type=script&lang=ts"
export * from "./ListeFicheStock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__